/**
 * @author Javier Ojeda
 * @date 22/10/2018
 * @description : Estilos globales para reutilizarlos en cualquier modal
 */
// @flow

export const ReactSelect = {
  control: (provided: any, state: any) => {
    return {
      ...provided,
      fontSize: '14px',
      borderRadius: '2px',
      boxShadow: 'none',
      borderColor: '#ECECEC',
      ':hover, :active': {
        borderColor: '#ECECEC',
        boxShadow: 'none'
      }
    };
  },
  menuList: (provided: any, state: any) => {
    return {
      ...provided,
      padding: 0,
      maxHeight: 152
    };
  },
  option: (provided: any, state: any) => {
    return {
      fontSize: '14px',
      cursor: 'pointer',
      display: 'block',
      padding: '8px 12px',
      borderRadius: '2px',
      userSelect: 'none',
      textAlign: 'left',
      backgroundColor: state.isSelected
        ? '#278C7E'
        : state.isFocused
        ? '#D9E7E4'
        : '#FFF',
      color: state.isSelected ? 'white' : '#333',
      ':hover': {
        backgroundColor: state.isSelected ? '#278C7E' : '#D9E7E4',
        color: state.isSelected ? 'white' : '#333'
      }
    };
  },
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    color: '#333',
    ':hover': {
      color: '#333'
    }
  }),
  indicatorSeparator: () => ({
    display: 'none'
  })
};

export const ReactSelectCardSaved = {
  control: (provided: any, state: any) => {
    return {
      ...provided,
      fontSize: '14px',
      borderRadius: '2px',
      boxShadow: 'none',
      borderColor: '#ECECEC',
      ':hover, :active': {
        borderColor: '#ECECEC',
        boxShadow: 'none'
      }
    };
  },
  menuList: (provided: any, state: any) => {
    return {
      ...provided,
      padding: 0,
      maxHeight: 152
    };
  },
  option: (provided: any, state: any) => {
    return {
      cursor: 'pointer',
      display: 'block',
      padding: '8px 12px',
      borderRadius: '2px',
      userSelect: 'none',
      textAlign: 'left',
      backgroundColor: state.isSelected
        ? '#278C7E'
        : state.isFocused
        ? '#D9E7E4'
        : '#FFF',
      color: state.isSelected ? 'white' : '#333',
      ':hover': {
        backgroundColor: state.isSelected ? '#278C7E' : '#D9E7E4',
        color: state.isSelected ? 'white' : '#333'
      }
    };
  },
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    color: '#333',
    ':hover': {
      color: '#333'
    }
  }),
  indicatorSeparator: () => ({
    display: 'none'
  })
};

export const ReactSelectTypeWork = {
  control: (provided: any, state: any) => {
    return {
      ...provided,
      fontSize: '14px',
      borderRadius: '2px',
      boxShadow: 'none',
      borderColor: '#ECECEC',
      ':hover, :active': {
        borderColor: '#ECECEC',
        boxShadow: 'none'
      }
    };
  },
  menuList: (provided: any, state: any) => {
    return {
      ...provided,
      padding: 0,
      maxHeight: 152
    };
  },
  option: (provided: any, state: any) => {
    return {
      fontSize: '14px',
      cursor: 'pointer',
      display: 'block',
      padding: '8px 12px',
      borderRadius: '2px',
      userSelect: 'none',
      textAlign: 'left',
      backgroundColor: state.isSelected
        ? '#278C7E'
        : state.isFocused
        ? '#D9E7E4'
        : '#FFF',
      color: state.isSelected ? 'white' : '#333',
      ':hover': {
        backgroundColor: state.isSelected ? '#278C7E' : '#D9E7E4',
        color: state.isSelected ? 'white' : '#333'
      }
    };
  },
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    color: '#333',
    ':hover': {
      color: '#333'
    }
  }),
  indicatorSeparator: () => ({
    display: 'none'
  })
};
